const MultiUsersIcon = ({ active }) => {
  const color = active ? "#0149AD" : "#545454";
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6351 11H11.9414C12.6601 11 13.2317 10.6726 13.7449 10.2147C15.0488 9.05161 11.9838 7.875 10.9375 7.875M9.6875 1.66798C9.82941 1.63983 9.97679 1.625 10.128 1.625C11.2654 1.625 12.1875 2.46447 12.1875 3.5C12.1875 4.53553 11.2654 5.375 10.128 5.375C9.97679 5.375 9.82941 5.36017 9.6875 5.33202"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M2.80082 8.56949C2.06396 8.96437 0.131961 9.77068 1.30868 10.7796C1.88349 11.2725 2.52369 11.625 3.32858 11.625H7.92142C8.72631 11.625 9.3665 11.2725 9.94132 10.7796C11.118 9.77068 9.18604 8.96437 8.44918 8.56949C6.72126 7.6435 4.52874 7.6435 2.80082 8.56949Z"
        stroke={color}
      />
      <path
        d="M8.125 3.1875C8.125 4.56821 7.00571 5.6875 5.625 5.6875C4.24429 5.6875 3.125 4.56821 3.125 3.1875C3.125 1.80679 4.24429 0.6875 5.625 0.6875C7.00571 0.6875 8.125 1.80679 8.125 3.1875Z"
        stroke={color}
      />
    </svg>
  );
};

export default MultiUsersIcon;
